/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, memo, useEffect } from "react";

import { Row, Col, Card, Spinner, Button } from "reactstrap";

import "react-perfect-scrollbar/dist/css/styles.css";

import ScrollContainer from "react-indiana-drag-scroll";

import noChat from "../../../../assets/images/404.png";

// // --> 2/4 of the screen
// import PreviousConversations from "../PreviousConversations/index";
import ChatArea from "../ActiveChat/subcomponents/chatArea/chatArea";
import MessageSystem from "../ActiveChat/subcomponents/messageSystem/messageSystem";

import TicketChat from "../TicketChat";

import EngagementHistory from "../EngagementHistory/index";

// --> 4/4 of the screen
import ClientInformation from "../ClientInformation/index";

import QuickReplies from "../QuickReplies/index";

// --> Scripts
import Scripts from "../Scripts/index";

// --> Widgets
import Widgets from "../Widgets";
import WidgetIFrame from "../CustomWidget";

import AttachmentList from "../../../Common/AttachmentsInteraction";

//Redux
import { useSelector, useDispatch } from "react-redux";

// Moment
import moment from "moment";

import { getActiveMsgs } from "../../functions/chat";

import { setLocalStorageWidgets } from "../../../LocalStorage/LocalStorageWidgets";

import {
  getWidgets,
  getWidget,
  unMountWidget,
} from "../../../../store/widgets/actions";

// actions
import {
  setMessage,
  getConsumerMessages,
} from "../../../../store/operator/actions";

import MessageItem from "../PreviousConversations/subcomponents/MessageItem/MessageItem";
import RichInputs from "../PreviousConversations/subcomponents/RichInputs.js";
import MenuButtons from "../PreviousConversations/subcomponents/MenuButtons";

import ReopenConversation from "../PreviousConversations/ReopenConversation";
import { useTranslation } from "react-i18next";
import ButtonCloseSpy from "./components/buttonCloseSpy";
import AditionalFields from "../AditionalFields";
import Summaries from "../Summaries/index.js";
import { useAutomaticSummarization } from "../../../../hooks/useAutomaticSummarization.js";

const hideComponentMessages = ["telefone"];

function AttendanceComponent({
  hideEngagementHistory,
  getChat,
  updateChat,
  chatImages,
  toggleTabChat,
  toggleTransfChat,
  toggleCloseChat,
  togglePrivateMsg,
  conversationDownload,
  spyConversation,
  handleMsgSubmit,
  insertCurrentUser,
  toggleTabTicket,
  toggleTabCommentary,
  scrollToBottom,
  updateEngagement,
  endPosChat,
  skillIdToShowMsg,
  showChat,
  activeChat,
  setActiveChat,
  engagementHistory,
  setEngagementHistory,
  agentSpy,
}) {
  const { data } = useSelector((state) => state.Login);

  const hasPermissionAditionalFieldsRead = useMemo(() => {
    const { permissions = [] } = data ?? {};
    return permissions["additional_fields_widgets"]?.includes("get") ?? false;
  }, [data]);
  const skillSummaryActived = activeChat?.conversation?.isAiSummaryEnabled;
  const hasObserver= spyConversation ? true : false;

  const { refresh } = useAutomaticSummarization();

  const isTicket = activeChat?.conversation?.channel === "real_automation";
  const { messageOperator, messageConsumer } = useSelector(
    (state) => state.Operator
  );

  const { t } = useTranslation();

  const objFeatureTab = data?.features?.find((e) => e.name === "Tab");
  const objFeatureDownload = data?.features?.find(
    (e) => e.name === "Download chat"
  );
  const { status: starStatus } = useSelector((state) => state.FavoriteMessages);
  const { status: insightStatus } = useSelector((state) => state.Insights);
  const { info: conversationInfo } = useSelector(
    (state) => state.ClientInformation
  );
  const { widgets: widgetsList, conversations: widgetsConversation } =
    useSelector((state) => state.CustomWidgets);

  const dispatch = useDispatch();
  const [messageWindowExpanded, setMessageWindowExpanded] = useState(false);
  const [widgetExpanded, setWidgetExpanded] = useState(false);

  const [additionalField, setAdditionalField] = useState(false);

  const [clientInformation, setClientInformation] = useState(false);
  const [quickReplies, setQuickReplies] = useState(false);
  const [scripts, setScripts] = useState(false);
  const [summary, setsummary] = useState(false);
  const [quickMsg, setQuickMsg] = useState("");

  const [customWidgets, setCustomWidgets] = useState({});
  const defaultMsgsQtd = 15;

  let localStorageWidgets =
    localStorage.getItem("widgetsControler") &&
    localStorage.getItem("widgetsControler");
  useEffect(() => {
    setLocalStorageWidgets(
      engagementHistory,
      clientInformation,
      quickReplies,
      scripts,
      summary,
      messageWindowExpanded,
      widgetExpanded,
      customWidgets
    );
  }, [
    engagementHistory,
    clientInformation,
    quickReplies,
    summary,
    scripts,
    messageWindowExpanded,
    widgetExpanded,
    customWidgets,
  ]);
  useEffect(() => {
    if (localStorageWidgets) {
      const widgetsController = JSON.parse(localStorageWidgets);
      if (widgetsController?.widgetsVisibility?.engagementHistory) {
        setEngagementHistory(true);
      }
      if (widgetsController?.widgetsVisibility?.clientInformation) {
        setClientInformation(true);
      }
      if (widgetsController?.widgetsVisibility?.quickReplies) {
        setQuickReplies(true);
      }
      if (widgetsController?.widgetsVisibility?.scripts) {
        setScripts(true);
      }
      if (widgetsController?.widgetsVisibility?.messageWindowExpanded) {
        setMessageWindowExpanded(true);
      }
      if (widgetsController?.widgetsVisibility?.widgetExpanded) {
        setWidgetExpanded(true);
      }
      if (widgetsController?.widgetsVisibility?.customWidgets) {
        setCustomWidgets(widgetsController.widgetsVisibility.customWidgets);
      }
    }
  }, []);

  const componentMessagesIsVisible = useMemo(() => {
    if (!activeChat?.conversation) return true;

    return !hideComponentMessages.includes(activeChat.conversation.channel);
  }, [activeChat]);

  function handleCustomWidgets(widgetId) {
    setCustomWidgets((prev) => ({
      ...prev,
      [widgetId]: !prev[widgetId],
    }));
  }

  const getMsg = (msgId, chat) => {
    let index = chat?.message?.findIndex((e) => e?.currentId === msgId) ?? -1;
    let msg = index >= 0 ? chat?.message[index] : null;
    return {
      index: index,
      msg: msg,
    };
  };

  const updateMsg = (chatId, obj) => {
    if (typeof obj === "object" && obj !== null) {
      let chats = messageOperator?.chats;
      let chat = getChat(chatId);
      let msgs = chat?.chat?.message;
      let msg = getMsg(obj?.currentId, chat?.chat);
      let newObj = null;

      if (msg?.msg) {
        msgs[msg?.index] = { ...msg?.msg, ...obj };
        chats.data[chat?.index] = { ...chat?.chat, message: msgs };
        newObj = chats;
        updateChat(newObj);
      }
    }
  };

  const updateDisplayName = (consumerId, displayName) => {
    if (messageOperator?.chats?.data) {
      let aux = messageOperator.chats;
      let pos = "";

      if (aux?.data) {
        pos = aux?.data?.findIndex((e) => e?.consumer?.id === consumerId);
        if (pos > -1) {
          aux.data[pos] = {
            ...aux.data[pos],
            consumer: { ...aux.data[pos].consumer, displayName: displayName },
          };
          // Update Active Chat
          if (activeChat?.conversation?.consumer?.id === consumerId) {
            setActiveChat(() => ({
              ...activeChat,
              conversation: {
                ...activeChat?.conversation,
                consumer: {
                  ...activeChat?.conversation?.consumer,
                  displayName: displayName,
                },
              },
            }));
          }
          // Update Store
          dispatch(setMessage(aux));
        }
      }
    }
  };
  const handleDayTitle = (chat, pos) => {
    let lastDate = chat[pos - 1]
      ? moment(chat[pos - 1].sentTime).format("DD/MM/YYYY")
      : null;
    let date =
      chat[pos] && chat[pos].sentTime
        ? moment(chat[pos].sentTime).format("DD/MM/YYYY")
        : null;
    let today = moment().format("DD/MM/YYYY");
    let yesterday = moment().subtract(1, "days").format("DD/MM/YYYY");

    let title =
      date !== null && date !== lastDate ? (
        <MessageSystem
          msg={date === today ? "Hoje" : date === yesterday ? "Ontem" : date}
          striped={false}
        />
      ) : (
        ""
      );
    return title;
  };

  const engagementItems = useMemo(() => {
    let chats =
      activeChat?.conversation?.consumer?.id &&
      messageConsumer?.chats?.data &&
      messageConsumer?.chats?.data[activeChat?.conversation?.consumer?.id];
    let status = messageConsumer?.status;

    let empty = {
      status: "disabled",
      temp: null,
      consumer: null,
      data: [],
    };

    let items = status
      ? status.get_conversations && status.get_conversations.loading
        ? {
            status: "loading",
            consumer: null,
            data: [],
          }
        : chats && chats.length > 0
        ? {
            status: "active",
            consumer: activeChat?.conversation?.consumer?.id,
            data: chats,
          }
        : empty
      : empty;
    return items;
  }, [messageConsumer, activeChat]);

  const showMessages = useMemo(() => {
    // const conversation = activeChat && activeChat.conversation;

    // TEMP
    const conversation = messageOperator?.chats?.data?.find(
      (e) => e.conversationId === activeChat?.conversation?.conversationId
    );

    const getSender = (chat, msg) => {
      let agent = conversation?.users
        ? conversation?.users?.find((e) => e?.user_id === msg?.userId)
        : [];
      agent = agent?.user_name;

      return msg?.systemMessage
        ? t("System message")
        : msg.userId
        ? agent
          ? agent
          : t("Agent")
        : chat?.consumer?.name;
    };

    const getConsumerMsgs = () => {
      let chatId = conversation?.conversationId ?? null;
      let chats = messageConsumer?.messages ?? null;
      let msgs = chats && chatId ? chats[chatId] : null;

      const checkEOF = (msgs) => {
        let totalMessages = msgs && msgs.length;
        if (!msgs) {
          return false;
        } else if (
          (msgs &&
            msgs.length > 0 &&
            msgs[msgs.length - 1].type &&
            msgs[msgs.length - 1].type === "eof") ||
          totalMessages % defaultMsgsQtd !== 0
        ) {
          return true;
        }
        return false;
      };

      const getClosedMessages = (page, isPagination) => {
        if (
          (!chats ||
            (chats && !msgs) ||
            (isPagination && chats && msgs && !checkEOF(msgs))) &&
          !(
            messageConsumer?.status?.get_messages?.loading ||
            messageConsumer?.status?.get_messages?.success
          )
        ) {
          dispatch(getConsumerMessages(chatId ?? null, page, defaultMsgsQtd));
        }
      };

      let loading = (
        <div className="w-100 text-center">
          <Spinner animation="border" size="sm" className="spinner" />
        </div>
      );
      let loading2 = (
        <div className="w-100 pb-3 text-center">
          <Spinner
            animation="border"
            size="sm"
            className="spinner my-2 smallSpinner"
          />
        </div>
      );
      let loadMore = (
        <div
          className="w-100 pb-4 text-center loadOlderMessages"
          onClick={() => {
            let totalMessages = msgs.length;
            let page = totalMessages / defaultMsgsQtd + 1;

            if (!checkEOF(msgs)) getClosedMessages(page, true);
          }}
        >
          {t("Load older messages...")}
        </div>
      );
      let empty = (
        <div className="w-100 py-3 text-center">
          {t("No matching records found")}
        </div>
      );

      if (msgs) {
        return msgs?.length > 0
          ? msgs.map((msg, key) => (
              <div key={key}>
                {key === 0
                  ? messageConsumer?.data?.id === chatId &&
                    messageConsumer?.status?.get_messages?.loading
                    ? loading2
                    : !checkEOF(msgs) && loadMore
                  : null}
                {!(msg?.type === "eof") && (
                  <div className={`d-flex flex-column`}>
                    {handleDayTitle(msgs, key)}
                    <MessageItem
                      isRight={(msg?.userId || msg?.systemMessage) && true}
                      name={getSender(conversation, msg)}
                      message={msg?.text}
                      msg={{
                        ...msg,
                        chatId: activeChat?.conversation?.conversationId,
                      }}
                      file={msg?.files}
                      pics={chatImages}
                      time={msg?.sentTime}
                      enableStarMsg={false}
                      hasObserver={hasObserver}
                      isSkillSummaryActived={skillSummaryActived}
                    />
                  </div>
                )}
              </div>
            ))
          : empty;
      } else {
        return messageConsumer && messageConsumer.status
          ? (messageConsumer.status.get_conversations &&
              messageConsumer.status.get_conversations.loading) ||
            (messageConsumer.status.get_messages &&
              messageConsumer.status.get_messages.loading)
            ? loading
            : getClosedMessages(1)
          : "";
      }
    };

    return conversation && conversation.status === "closed"
      ? getConsumerMsgs()
      : conversation && conversation.message && conversation.message.length > 0
      ? getActiveMsgs(
          conversation,
          handleDayTitle,
          getSender,
          activeChat,
          chatImages,
          updateMsg,
          t
        )
      : "";
  }, [messageConsumer, activeChat, messageOperator]);

  const renderMenuButtons = (activeConversation, chats) => {
    const { conversationId } = activeConversation;
    const chat = (chats || []).find((e) => e.conversationId === conversationId);

    if (chat) {
      const { status } = chat;

      const optionsMenuClosedChat = [
        {
          value: "tab",
          text: "Tabulação",
          shortcut: "ALT + I",
          action: (e) => toggleTabChat(e),
          isHidden: !objFeatureTab?.active,
        },
      ];
      const optionsMenuOpenChat = [
        {
          value: "transferChat",
          text: "Transfer chat",
          shortcut: "ALT + T",
          action: (e) => toggleTransfChat(e),
        },
        {
          value: "tab",
          text: "Tabulation",
          shortcut: "ALT + I",
          action: (e) => toggleTabChat(e),
          isHidden: !objFeatureTab?.active,
        },
        {
          value: "closeChat",
          text: "Close chat",
          shortcut: "ALT + C",
          action: (e) => toggleCloseChat(e),
        },
        {
          value: "privateMsg",
          text: "Private message",
          shortcut: "ALT + P",
          action: (e) => togglePrivateMsg(e),
        },
        {
          value: "download",
          text: "Download chat",
          shortcut: "ALT + X",
          action: (e) => conversationDownload(),
          isHidden: !objFeatureDownload?.active,
        },
      ];

      switch (status) {
        case "pre-chat":
        case "pos-chat":
          return (
            <MenuButtons
              id={activeConversation?.consumer?.id}
              chatId={activeConversation?.conversationId}
              displayName={
                activeConversation?.consumer?.displayName ??
                activeConversation?.consumer?.name
              }
              name={activeConversation?.consumer?.name}
              onChangeDisplayName={updateDisplayName}
              enableMoreOptions={false}
            />
          );

        case "closed":
          return (
            <MenuButtons
              id={activeConversation?.consumer?.id}
              chatId={activeConversation?.conversationId}
              displayName={
                activeConversation?.consumer?.displayName ??
                activeConversation?.consumer?.name
              }
              name={activeConversation?.consumer?.name}
              onChangeDisplayName={updateDisplayName}
              enableMoreOptions={true}
              moreOptions={{
                options: optionsMenuClosedChat,
              }}
              moreOpAction={(e) => {
                optionsMenuClosedChat
                  .find((element) => element.value === e)
                  .action();
              }}
            />
          );

        default:
          return (
            <MenuButtons
              id={activeConversation?.consumer?.id}
              displayName={
                activeConversation?.consumer?.displayName ??
                activeConversation?.consumer?.name
              }
              name={activeConversation?.consumer?.name}
              onChangeDisplayName={updateDisplayName}
              enableMoreOptions={true}
              moreOptions={{
                options: optionsMenuOpenChat,
              }}
              moreOpAction={(e) => {
                optionsMenuOpenChat
                  .find((element) => element.value === e)
                  ?.action();
              }}
            />
          );
      }
    }
  };

  const renderChatInput = (activeConversation, chats) => {
    const { conversationId } = activeConversation;
    const chat = (chats || []).find((e) => e.conversationId === conversationId);

    if (chat) {
      const { status } = chat;

      switch (status) {
        case "pre-chat":
          return (
            <div className="text-center p-3">
              <Button color="light" className="w-100 py-3" disabled={true}>
                {t("Pre chat survey in progress...")}
              </Button>
            </div>
          );

        case "pos-chat":
          return (
            <div className="text-center p-3">
              <Button color="light" className="w-100 py-3" disabled={true}>
                {t("Pos chat survey in progress...")}
              </Button>
            </div>
          );

        case "closed":
          return (
            <ReopenConversation
              chatId={activeConversation?.conversationId}
              byManager={!!spyConversation}
            />
          );

        default:
          return (
            <div className="chat-input-section">
              <RichInputs
                chatId={activeChat?.conversation?.conversationId}
                observer={{
                  hasObserver: spyConversation ? true : false,
                  joined:
                    !spyConversation ||
                    activeChat?.conversation?.users?.some(
                      (user) =>
                        spyConversation &&
                        user.user_id === data?.user?.id &&
                        user.joined
                    ),
                }}
                joinedConversation={() => {
                  let params = { joined: true };
                  insertCurrentUser(params);
                }}
                onSubmit={(e) => {
                  activeChat.sendMessage.values.text = e;
                  setQuickMsg("");
                  handleMsgSubmit();
                }}
                handleFile={(e) => {
                  let aux = {
                    ...activeChat.sendMessage.values,
                    file: e.file,
                  };
                  activeChat.sendMessage.values = aux;
                }}
                quickMsg={quickMsg}
                supportedFiles={activeChat?.conversation?.supportedFiles}
              />
            </div>
          );
      }
    }
  };

  const showWidgets = () => {
    return Object.values(widgetsConversation)?.map((e) =>
      Object.values(e).map((el, key) => (
        <>
          {!el?.unMounted && (
            <Col
              className={`h-100 ${
                activeChat?.conversation?.conversationId === el?.chatId
                  ? "appear"
                  : "disappear"
              }`}
              style={{
                display:
                  customWidgets?.[el?.widgetId] &&
                  activeChat?.conversation?.conversationId === el?.chatId
                    ? "block"
                    : "none",
              }}
            >
              {el.data && (
                <WidgetIFrame
                  key={key}
                  id={`${el.chatId}${el?.id}`}
                  isOpen
                  {...el}
                />
              )}
            </Col>
          )}
        </>
      ))
    );
  };

  const style = {
    widgets: {
      width: {
        maxWidth: "320px",
        minWidth: "320px",
      },
    },
  };

  const optionsMenuOpenTicket = [
    {
      value: "transferChat",
      text: "Transfer chat",
      shortcut: "ALT + T",
      action: (e) => toggleTransfChat(e),
    },
    {
      value: "tab",
      text: "Tabulation",
      shortcut: "ALT + I",
      action: (e) => toggleTabTicket(e),
      isHidden: !objFeatureTab?.active,
    },
    {
      value: "commentary",
      text: "Inserir comentário",
      shortcut: "ALT + M",
      action: () => toggleTabCommentary(),
    },
  ];

  function callWidget(chatId, skillId) {
    const widget = widgetsList?.find(
      (el) => el.name === "Link" && el.skill_id === skillId
    );
    if (widget) {
      dispatch(getWidget(chatId, widget?.id));
    }
  }

  useEffect(() => {
    const chatId = activeChat?.conversation?.conversationId;
    if (!!widgetsConversation[chatId]) return;

    if (chatId && widgetsList?.length > 0 && conversationInfo?.[chatId]) {
      const skillId =
        conversationInfo?.[chatId]?.conversationInformation?.skill_id;
      callWidget(chatId, skillId);
    }
  }, [activeChat?.conversation?.conversationId, conversationInfo]);

  useEffect(() => {
    if (widgetsList?.length > 0) return;
    dispatch(getWidgets());
  }, []);

  useEffect(() => {
    const chatId = activeChat?.conversation?.conversationId;
    if (chatId && widgetsConversation[chatId]) {
      Object.values(widgetsConversation[chatId]).forEach((el) => {
        if (el?.unMounted) {
          dispatch(unMountWidget(el?.chatId, el?.widgetId, false));
        }
      });
    }
  }, [activeChat?.conversation?.conversationId]);

  useEffect(() => {
    const chatId = activeChat?.conversation?.conversationId;
    if (!isTicket && chatId) refresh({ isAutomaticSummarizationEnabled: skillSummaryActived });
  }, [skillSummaryActived, isTicket, activeChat?.conversation?.conversationId]);

  return (
    <>
      {componentMessagesIsVisible && (
        <Col
          className="h-100 user-chat"
          style={{
            maxWidth: `${messageWindowExpanded ? "840" : "465"}px`,
            minWidth: `${messageWindowExpanded ? "465" : "440"}px`,
          }}
        >
          <Row className="h-100">
            <Col className="h-100" id="dc">
              <Card className="h-100">
                {activeChat.conversation &&
                activeChat.conversation.conversationId !== "" ? (
                  /* Conversation */

                  <>
                    {agentSpy && <ButtonCloseSpy agentSpy={agentSpy} />}
                    {activeChat.conversation &&
                    activeChat.conversation?.channel === "real_automation" ? (
                      <>
                        <div className="h-100">
                          <TicketChat
                            conversation={activeChat}
                            moreOtions={
                              activeChat?.conversation?.status !== "closed"
                                ? {
                                    options: optionsMenuOpenTicket,
                                  }
                                : {}
                            }
                            moreOpAction={(e) => {
                              optionsMenuOpenTicket
                                .find((element) => element.value === e)
                                ?.action();
                            }}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        {/* Chat header */}
                        <div>
                          {renderMenuButtons(
                            activeChat.conversation,
                            messageOperator?.chats?.data
                          )}
                        </div>
                        {/* Chat messages*/}
                        <div
                          className="chat-conversation p-3 h-100 smoothScroll"
                          style={{
                            overflow: "auto",
                          }}
                        >
                          <ChatArea
                            showMessages={showMessages}
                            chatId={activeChat?.conversation?.conversationId}
                            scrollToBottom={scrollToBottom}
                          />
                        </div>
                        {/* Chat input */}
                        {renderChatInput(
                          activeChat.conversation,
                          messageOperator?.chats?.data
                        )}
                      </>
                    )}
                  </>
                ) : (
                  /* No Conversation */
                  <div className="widgetSection d-flex align-items-center h-100 p-4">
                    <div className="d-flex flex-column">
                      <label
                        className="font-weight-bold font-size-16 text-center mb-5 pb-2"
                        style={{ opacity: 0.7 }}
                      >
                        {t("No conversations selected")}
                      </label>
                      {/* TODO: replace it for correct image */}
                      <img
                        src={noChat}
                        alt="No chat selected"
                        className="img-fluid my-auto"
                        style={{ opacity: ".4" }}
                      />
                    </div>
                  </div>
                )}
              </Card>
            </Col>
            <Row className="h-100">
              <Col
                className="h-100 d-flex align-items-center pr-4"
                style={{
                  padding: componentMessagesIsVisible ? "0px" : "20px",
                }}
              >
                {componentMessagesIsVisible && (
                  <button
                    type="button"
                    className="btn btn-primary pt-3 pb-3 pl-1 pr-1"
                    onClick={() => {
                      setMessageWindowExpanded((prev) => !prev);
                    }}
                  >
                    <i
                      className={`icon-conversation-arrow mdi mdi-chevron-right ${
                        messageWindowExpanded ? "active" : ""
                      } font-size-24 `}
                    />
                  </button>
                )}
              </Col>
            </Row>
          </Row>
        </Col>
      )}
      {/* Widgets Container */}
      <>
        <ScrollContainer
          className="ml-2 widgetscontainer"
          vertical={false}
          horizontal={true}
          ignoreElements=".escapeDragScroll, input, textarea, label"
          hideScrollbars={false}
          style={
            componentMessagesIsVisible
              ? {
                  width: `${
                    messageWindowExpanded
                      ? "calc(100% - 90em)"
                      : "calc(100% - 800px)"
                  }`,
                }
              : {
                  width: "calc(100% - 28em)",
                }
          }
        >
          <Row
            className="h-100 d-flex flex-nowrap"
            style={{
              width: "min-content",
            }}
          >
            {activeChat.conversation?.channel === "real_automation" && (
              <Col className="h-100" style={style.widgets.width}>
                <Row className="mb-2 h-100">
                  <Col className="h-100">
                    <AttachmentList
                      activeChat={activeChat?.conversation?.conversationId}
                      isSpy={!!spyConversation}
                    />
                  </Col>
                </Row>
              </Col>
            )}
            {/* EngagementHistory */}
            <Col
              className={`h-100 ${engagementHistory ? "appear" : "disappear"}`}
              style={style.widgets.width}
            >
              <Row className="mb-2 h-100">
                <Col className="h-100">
                  <EngagementHistory
                    isVisible={
                      activeChat?.conversation?.conversationId !== ""
                        ? true
                        : false
                    }
                    chats={engagementItems}
                    update={updateEngagement}
                  />
                </Col>
              </Row>
            </Col>
            {/* Aditional Fields */}
            {additionalField &&
              isTicket &&
              hasPermissionAditionalFieldsRead && (
                <div>
                  <Col
                    xs={4}
                    className={`h-100 ${
                      additionalField ? "appear" : "disappear"
                    }`}
                    style={style.widgets.width}
                  >
                    <Row className="mb-2 h-100">
                      <Col className="h-100">
                        <AditionalFields
                          chatId={activeChat?.conversation?.conversationId}
                          update={
                            // TODO: Update chat status without call API, "messageOperator?.status?.disable_chat?.success", this work but call API unecessary
                            messageOperator?.status?.get_messages?.success ||
                            // TODO: review methods below, they are unecessary (just call API when recive a new conversation)
                            messageOperator?.status?.tabulate_chat?.success ||
                            insightStatus?.set_insights?.success ||
                            starStatus?.star_message?.success ||
                            endPosChat
                          }
                          moreOptionsVisible={!componentMessagesIsVisible}
                          moreOptions={
                            activeChat?.conversation?.status !== "closed"
                              ? [
                                  {
                                    value: "transferChat",
                                    text: "Transfer chat",
                                    shortcut: "ALT + T",
                                    action: (e) => toggleTransfChat(e),
                                  },
                                  {
                                    value: "tab",
                                    text: "Tabulation",
                                    shortcut: "ALT + I",
                                    action: (e) => toggleTabChat(e),
                                    isHidden: !objFeatureTab?.active,
                                  },
                                  {
                                    value: "closeChat",
                                    text: "Close chat",
                                    shortcut: "ALT + C",
                                    action: (e) => toggleCloseChat(e),
                                  },
                                ]
                              : [
                                  {
                                    value: "tab",
                                    text: "Tabulation",
                                    shortcut: "ALT + I",
                                    action: (e) => toggleTabChat(e),
                                    isHidden: !objFeatureTab?.active,
                                  },
                                ]
                          }
                        />
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}

            {/* ClientInformation */}
            <Col
              xs={4}
              className={`h-100 ${clientInformation ? "appear" : "disappear"}`}
              style={style.widgets.width}
            >
              <Row className="mb-2 h-100">
                <Col className="h-100">
                  <ClientInformation
                    chatId={activeChat?.conversation?.conversationId}
                    update={
                      // TODO: Update chat status without call API, "messageOperator?.status?.disable_chat?.success", this work but call API unecessary
                      messageOperator?.status?.get_messages?.success ||
                      // TODO: review methods below, they are unecessary (just call API when recive a new conversation)
                      messageOperator?.status?.tabulate_chat?.success ||
                      insightStatus?.set_insights?.success ||
                      starStatus?.star_message?.success ||
                      endPosChat
                    }
                    moreOptionsVisible={!componentMessagesIsVisible}
                    moreOptions={
                      activeChat?.conversation?.status !== "closed"
                        ? [
                            {
                              value: "transferChat",
                              text: "Transfer chat",
                              shortcut: "ALT + T",
                              action: (e) => toggleTransfChat(e),
                            },
                            {
                              value: "tab",
                              text: "Tabulation",
                              shortcut: "ALT + I",
                              action: (e) => toggleTabChat(e),
                              isHidden: !objFeatureTab?.active,
                            },
                            {
                              value: "closeChat",
                              text: "Close chat",
                              shortcut: "ALT + C",
                              action: (e) => toggleCloseChat(e),
                            },
                          ]
                        : [
                            {
                              value: "tab",
                              text: "Tabulation",
                              shortcut: "ALT + I",
                              action: (e) => toggleTabChat(e),
                              isHidden: !objFeatureTab?.active,
                            },
                          ]
                    }
                  />
                </Col>
              </Row>
            </Col>
            {/* QuickReplies */}
            <Col
              className={`h-100 ${quickReplies ? "appear" : "disappear"}`}
              style={style.widgets.width}
            >
              <Row className="mb-2 h-100">
                <Col className="h-100">
                  <QuickReplies
                    skillId={skillIdToShowMsg}
                    showChat={showChat}
                    onClick={(e) => {
                      setQuickMsg(e);
                    }}
                  />
                </Col>
              </Row>
            </Col>
            {/* Summaries */}
            {!isTicket && skillSummaryActived && (
              <Col
                className={`h-100 ${summary ? "appear" : "disappear"}`}
                style={style.widgets.width}
              >
                <Row className="mb-2 h-100">
                  <Col className="h-100">
                    <Summaries
                      chatId={activeChat?.conversation?.conversationId}
                      skillId={skillIdToShowMsg}
                      showChat={showChat}
                    ></Summaries>
                  </Col>
                </Row>
              </Col>
            )}

            {/* Scripts */}
            <Col
              className={`h-100 ${scripts ? "appear" : "disappear"}`}
              style={style.widgets.width}
            >
              <Row className="mb-2 h-100">
                <Col className="h-100">
                  <Scripts
                    skillId={skillIdToShowMsg}
                    showChat={showChat}
                    onClick={(e) => {
                      setQuickMsg(e);
                    }}
                  />
                </Col>
              </Row>
            </Col>
            {showWidgets()}
          </Row>
        </ScrollContainer>

        {/* Widgets RightBar  */}
        <div
          lg="1"
          className="h-100 position-fixed"
          style={{
            right: "0",
            pointerEvents: "none",
          }}
        >
          <Widgets
            skillSummaryActived={skillSummaryActived}
            isTicket={activeChat?.conversation?.channel === "real_automation"}
            chatId={activeChat?.conversation?.conversationId}
            additionalField={additionalField}
            onClickAdditionalField={() => {
              setAdditionalField((old) => !old);
            }}
            fillColorAdditionalField={additionalField ? "#51A6F1" : "#2A3143"}
            fillColorAdditionalFieldL={additionalField ? "#51A6F1" : "white"}
            hideEngagementHistory={hideEngagementHistory}
            onclickOne={() => {
              setEngagementHistory((old) => !old);
            }}
            widgetExpanded={!widgetExpanded}
            setWidgetExpanded={setWidgetExpanded}
            fillcolorOne={engagementHistory ? "#51A6F1" : "#2A3143"}
            fillcolorOneL={engagementHistory ? "#51A6F1" : "white"}
            onclickTwo={() => {
              setClientInformation((old) => !old);
            }}
            fillcolorTwo={clientInformation ? "#51A6F1" : "#2A3143"}
            fillcolorTwoL={clientInformation ? "#51A6F1" : "white"}
            onclickThree={() => {
              setQuickReplies((old) => !old);
            }}
            styleThree={{
              backgroundColor: quickReplies && "#51A6F1",
            }}
            fillcolorThree={clientInformation ? "#51A6F1" : "#2A3143"}
            fillcolorThreeL={clientInformation ? "#51A6F1" : "white"}
            onclickScripts={() => {
              setScripts((old) => !old);
            }}
            onClickSummary={() => {
              setsummary((old) => !old);
            }}
            styleScripts={{
              backgroundColor: scripts && "#51A6F1",
            }}
            styleSummary={{
              backgroundColor: summary && "#51A6F1",
            }}
            handleCustomWidgets={handleCustomWidgets}
            customWidgets={customWidgets}
            fillcolorFour={["#51A6F1", "#2A3143"]}
            fillcolorFourL={["#51A6F1", "white"]}
          />
        </div>
      </>
    </>
  );
}

export default memo(AttendanceComponent);
